import { call, put } from "redux-saga/effects";
import { ACTIONS, API_URL, sagaFunction } from "../_config";
import { CallApi } from "./api/callApi";

export function* getEmployerJobs(action: any): any {
  try {
    const { employerId, params = {} } = action.payload || {};

    if (!employerId) {
      action && action.callbackError && action.callbackError("Employer ID is required");
      return;
    }

    const url = `${API_URL.JOB.EMPLOYER_JOBS}${employerId}`;
    const resp = yield call(CallApi.GET, url, params, true);

    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      yield put({
        type: ACTIONS.JOB.GET_EMPLOYER_JOBS,
        payload: resp.data.data.jobs,
      });

      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* getJobDetails(action: any): any {
  try {
    const { jobId } = action.payload || {};

    if (!jobId) {
      action && action.callbackError && action.callbackError("Job ID is required");
      return;
    }

    const url = `${API_URL.JOB.JOB_DETAILS}${jobId}`;
    const resp = yield call(CallApi.GET, url, {}, true);

    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* updateJobStatus(action: any): any {
  yield call(
    sagaFunction,
    action,
    CallApi.PUT,
    `${API_URL.JOB.UPDATE_STATUS}${action.payload.jobId}`,
    action.payload.data,
    true,
  );
}

export function* cloneJob(action: any): any {
  yield call(
    sagaFunction,
    action,
    CallApi.POST,
    `${API_URL.JOB.CLONE_JOB}${action.payload.jobId}`,
    action.payload.data,
    true,
  );
}

export function* getJobCandidates(action: any): any {
  try {
    const { jobId, params = {} } = action.payload || {};

    if (!jobId) {
      action && action.callbackError && action.callbackError("Job ID is required");
      return;
    }

    const url = API_URL.JOB.JOB_CANDIDATES(jobId);
    const resp = yield call(CallApi.GET, url, params, true);

    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      yield put({
        type: ACTIONS.JOB.GET_JOB_CANDIDATES,
        payload: resp.data.data,
      });

      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* getScreening(action: any): any {
  try {
    const { jobId, limit = 10, offset = 0, search, ...otherParams } = action.payload || {};

    if (!jobId) {
      action && action.callbackError && action.callbackError("Job ID is required");
      return;
    }

    const params: any = {
      job_id: jobId,
      limit,
      offset,
      ...otherParams, // Include any additional parameters
    };

    // Add search parameter if provided
    if (search && search.trim()) {
      params.search = search.trim();
    }

    const resp = yield call(CallApi.GET, API_URL.JOB.SCREENING, params, true);

    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      yield put({
        type: ACTIONS.JOB.GET_SCREENING,
        payload: resp.data.data,
      });

      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* getCandidateDetails(action: any): any {
  try {
    const { jobId, candidateId } = action.payload || {};

    if (!jobId) {
      action && action.callbackError && action.callbackError("Job ID is required");
      return;
    }

    if (!candidateId) {
      action && action.callbackError && action.callbackError("Candidate ID is required");
      return;
    }

    const url = API_URL.JOB.CANDIDATE_DETAILS(jobId, candidateId);
    const resp = yield call(CallApi.GET, url, {}, true);

    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      yield put({
        type: ACTIONS.JOB.GET_CANDIDATE_DETAILS,
        payload: resp.data.data,
      });

      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* getAiScreeningStatus(action: any): any {
  try {
    const { jobId } = action.payload || {};

    if (!jobId) {
      action && action.callbackError && action.callbackError("Job ID is required");
      return;
    }

    const url = API_URL.JOB.AI_SCREENING_STATUS(jobId);
    const resp = yield call(CallApi.GET, url, {}, true);

    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* getJobMatchingProgress(action: any): any {
  try {
    const { jobId } = action.payload || {};

    if (!jobId) {
      action && action.callbackError && action.callbackError("Job ID is required");
      return;
    }

    const url = API_URL.JOB.MATCHING_PROGRESS(jobId);
    const resp = yield call(CallApi.GET, url, {}, true);

    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* bulkResumeUpload(action: any): any {
  try {
    const { files, jobEmpId } = action.payload || {};

    if (!files || files.length === 0) {
      action && action.callbackError && action.callbackError("No files provided for upload");
      return;
    }

    if (!jobEmpId) {
      action && action.callbackError && action.callbackError("Job employer ID is required");
      return;
    }

    // Step 1: Get presigned upload URLs from Laravel API
    const uploadUrlsPayload = {
      job_emp_id: jobEmpId,
      files: files.map((f: File) => ({
        filename: f.name,
        size: f.size,
        mime_type: f.type,
      })),
    };

    const urlsResp = yield call(CallApi.POST, API_URL.JOB.RESUME_UPLOAD_URLS, uploadUrlsPayload, true);

    if (!(urlsResp.status >= 200 && urlsResp.status < 300 && urlsResp.data)) {
      action && action.callbackError && action.callbackError(urlsResp.data);
      return;
    }

    const { batch_id, upload_urls } = urlsResp.data.data;

    // Step 2: Upload files directly to S3 using presigned URLs
    yield call(() =>
      Promise.all(
        upload_urls.map((urlInfo: any, i: number) =>
          fetch(urlInfo.upload_url, {
            method: "PUT",
            headers: urlInfo.upload_headers,
            body: files[i],
          }).then((res) => {
            if (!res.ok) {
              throw new Error(`S3 upload failed for ${files[i].name}`);
            }
          }),
        ),
      ),
    );

    // Step 3: Notify Laravel to start processing
    const processResp = yield call(
      CallApi.POST,
      API_URL.JOB.RESUME_BATCH_PROCESS(batch_id),
      { uploaded_keys: upload_urls.map((u: any) => u.s3_key) },
      true,
    );

    if (processResp.status >= 200 && processResp.status < 300 && processResp.data) {
      action && action.callbackSuccess && action.callbackSuccess(processResp.data);
    } else {
      action && action.callbackError && action.callbackError(processResp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* getJobStatusCounts(action: any): any {
  try {
    const { jobIds = [] } = action.payload || {};

    // Build query parameters for job_ids[]
    const params: any = {};
    if (jobIds && jobIds.length > 0) {
      params["job_ids[]"] = jobIds;
    }

    const resp = yield call(CallApi.GET, API_URL.JOB.JOB_STATUS_COUNTS, params, true);

    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* getAppliedJobsLastSevenDays(action: any): any {
  try {
    const resp = yield call(CallApi.GET, API_URL.JOB.APPLIED_JOBS_LAST_SEVEN_DAYS, action.payload, true);

    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* getJobAllStatusCounts(action: any): any {
  try {
    const params: any = {};

    // Add job_ids[] array if provided
    if (action.payload?.job_ids && Array.isArray(action.payload.job_ids)) {
      action.payload.job_ids.forEach((jobId: string) => {
        if (!params["job_ids"]) params["job_ids"] = [];
        params["job_ids"].push(jobId);
      });
    }

    // Add date range if provided
    if (action.payload?.from_date) params.from_date = action.payload.from_date;
    if (action.payload?.to_date) params.to_date = action.payload.to_date;
    if (action.payload?.matching_percentage) params.matching_percentage = action.payload.matching_percentage;

    console.log("getJobAllStatusCounts params:", params);

    const resp = yield call(CallApi.GET, API_URL.JOB.JOB_ALL_STATUS_COUNTS, params, true);
    console.log("getJobAllStatusCounts response:", resp.data);

    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    console.log("Error in getJobAllStatusCounts saga:", e);
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* getJobseekerDetailsById(action: any): any {
  try {
    // jobseekerId is a CandidateRef: numeric for regular jobseekers, 24-hex ObjectId string for external (type-4). Never coerce to Number.
    const { jobseekerId, isBulkCV, isExternal, jobId } = action.payload || {};

    if (!jobseekerId) {
      action && action.callbackError && action.callbackError("Jobseeker ID is required");
      return;
    }

    const params: any = {
      jobseeker_id: jobseekerId,
    };

    // Add bulk_cv parameter if candidate is of type 3
    if (isBulkCV) {
      params.bulk_cv = 1;
    }

    // External (type 4) candidates live in jobseekers_external collections
    if (isExternal) {
      params.external = 1;
    }

    if (jobId) {
      params.job_id = String(jobId);
    }

    const resp = yield call(CallApi.GET, API_URL.JOB.JOBSEEKER_DETAILS_BY_ID, params, true);

    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* triggerMatching(action: any): any {
  try {
    const { jobEmpId } = action.payload || {};

    if (!jobEmpId) {
      action && action.callbackError && action.callbackError("Job Employer ID is required");
      return;
    }

    const url = API_URL.JOB.TRIGGER_MATCHING(jobEmpId);
    const resp = yield call(CallApi.POST, url, {}, true);

    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* deleteJob(action: any): any {
  yield call(
    sagaFunction,
    action,
    CallApi.DELETE,
    `${API_URL.JOB.DELETE_JOB}${action.payload.jobId}`,
    {},
    true,
  );
}

export function* userJobRefreshSet(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.JOB.USER_JOB_REFRESH_SET, action.payload, true);
}

export function* userJobRefreshRemove(action: any): any {
  yield call(sagaFunction, action, CallApi.DELETE, API_URL.JOB.USER_JOB_REFRESH_REMOVE, action.payload, true);
}

export function* userJobRefreshGet(action: any): any {
  try {
    const params = action.payload || {};
    const resp = yield call(CallApi.GET, API_URL.JOB.USER_JOB_REFRESH_GET, params, true);

    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* unlockCandidateBatch(action: any): any {
  try {
    const data = action.payload || {};
    const resp = yield call(CallApi.POST, API_URL.JOB.UNLOCK_CANDIDATE_BATCH, data, true);

    if (resp.status >= 200 && resp.status < 300) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* viewLinkedIn(action: any): any {
  try {
    const data = action.payload || {};
    const resp = yield call(CallApi.POST, API_URL.JOB.VIEW_LINKEDIN, data, true);

    if (resp.status >= 200 && resp.status < 300) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* unlockAndScreen(action: any): any {
  try {
    const data = action.payload || {};
    const resp = yield call(CallApi.POST, API_URL.JOB.UNLOCK_AND_SCREEN, data, true);

    if (resp.status >= 200 && resp.status < 300) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* bulkUnlockAndScreen(action: any): any {
  try {
    const data = action.payload || {};
    const resp = yield call(CallApi.POST, API_URL.JOB.BULK_UNLOCK_AND_SCREEN, data, true);

    if (resp.status >= 200 && resp.status < 300) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* inviteCandidate(action: any): any {
  try {
    const data = action.payload || {};
    const screeningId = String(data.screening_id || "");
    const resp = yield call(
      CallApi.POST,
      API_URL.JOB.INVITE_CANDIDATE(screeningId),
      {},
      true,
    );

    if (resp.status >= 200 && resp.status < 300) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* getCreditUsage(action: any): any {
  try {
    const resp = yield call(CallApi.GET, API_URL.JOB.CREDIT_USAGE, {}, true);

    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* validateCredit(action: any): any {
  try {
    const data = action.payload || {};
    const resp = yield call(CallApi.POST, API_URL.JOB.CREDIT_VALIDATE, data, true);

    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* getCreditHistory(action: any): any {
  try {
    const params = action.payload || {};
    const resp = yield call(CallApi.GET, API_URL.JOB.CREDIT_HISTORY, params, true);

    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* getCreditConfigurations(action: any): any {
  try {
    const resp = yield call(CallApi.GET, API_URL.JOB.CREDIT_CONFIGURATIONS, {}, true);

    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* sourceExternal(action: any): any {
  try {
    const data = action.payload || {};
    const resp = yield call(CallApi.POST, API_URL.JOB.SOURCE_EXTERNAL, data, true);

    if (resp.status >= 200 && resp.status < 300) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* sourceExternalMore(action: any): any {
  try {
    const data = action.payload || {};
    const resp = yield call(CallApi.POST, API_URL.JOB.SOURCE_EXTERNAL_MORE, data, true);

    if (resp.status >= 200 && resp.status < 300) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* sourceExternalCapacity(action: any): any {
  try {
    const data = action.payload || {};
    const resp = yield call(CallApi.POST, API_URL.JOB.SOURCE_EXTERNAL_CAPACITY, data, true);

    if (resp.status >= 200 && resp.status < 300) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

/** Shared handler: success on 2xx, otherwise the response body (code/message) to callbackError. */
function* callJobEndpoint(action: any, method: "GET" | "POST", url: string, data: any): any {
  try {
    const resp = yield call(method === "GET" ? CallApi.GET : CallApi.POST, url, data, true);
    if (resp.status >= 200 && resp.status < 300) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* getSearchDiagnosis(action: any): any {
  const { jobId, refresh } = action.payload || {};
  if (!jobId) {
    action && action.callbackError && action.callbackError("Job ID is required");
    return;
  }
  yield* callJobEndpoint(action, "GET", API_URL.JOB.SEARCH_DIAGNOSIS(jobId), refresh ? { refresh: 1 } : {});
}

export function* createSearchExpansion(action: any): any {
  const { jobId, ...body } = action.payload || {};
  if (!jobId) {
    action && action.callbackError && action.callbackError("Job ID is required");
    return;
  }
  // body.idempotency_key is sent as the Idempotency-Key header by CallApi.POST.
  yield* callJobEndpoint(action, "POST", API_URL.JOB.SEARCH_EXPANSION(jobId), body);
}

/** Read-only: estimates the selected suggestions together; starts no search. */
export function* estimateSearchExpansion(action: any): any {
  const { jobId, ...body } = action.payload || {};
  if (!jobId) {
    action && action.callbackError && action.callbackError("Job ID is required");
    return;
  }
  yield* callJobEndpoint(action, "POST", API_URL.JOB.SEARCH_EXPANSION_ESTIMATE(jobId), body);
}

export function* getLatestSearchExpansion(action: any): any {
  const { jobId } = action.payload || {};
  if (!jobId) {
    action && action.callbackError && action.callbackError("Job ID is required");
    return;
  }
  yield* callJobEndpoint(action, "GET", API_URL.JOB.SEARCH_EXPANSION(jobId), {});
}

export function* deactivateSearchExpansion(action: any): any {
  const { jobId, expansionId } = action.payload || {};
  if (!jobId || !expansionId) {
    action && action.callbackError && action.callbackError("Job and expansion are required");
    return;
  }
  yield* callJobEndpoint(action, "POST", API_URL.JOB.SEARCH_EXPANSION_DEACTIVATE(jobId, expansionId), {});
}
